import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useGetCheckSubscriptionMutation, useGetChatDetailsMutation } from 'services';
import useAuthStore from 'store/auth';
import useTranslate from 'hooks/useTranslate';
import { setIsLoading, setModalConfig } from 'store/common';
import { USER_TYPES } from 'constants';

interface ChatBtnProps {
	isBlock?: boolean;
	className?: string;
	receiverId: number;
	mode?: string;
}

const ChatBtn: React.FC<ChatBtnProps> = ({
	isBlock = false,
	className = 'filled-btn rounded-pill lh-1',
	receiverId = null,
	mode = 'icon',
}) => {
	const navigate = useNavigate();
	const { translate } = useTranslate();
	const { user: authUser }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	const { mutateAsync: getChatDetailsMutation } = useGetChatDetailsMutation();
	const { mutateAsync: checkSubscriptionMutation } = useGetCheckSubscriptionMutation();

	const handleClick = (e: any) => {
		e.stopPropagation();
		setIsLoading(true);
		if (authUser?.userType === USER_TYPES?.COMPANY) {
			checkSubscriptionMutation(`contact&chatUserId=${receiverId}`).then((res: any) => {
				if (res.success) {
					getRoomID();
				} else {
					callSubscriptionModal();
				}
			});
		} else {
			getRoomID();
		}
		setIsLoading(false);
	};

	const callSubscriptionModal = () => {
		setModalConfig({
			visible: true,
			type: 'subscriptionModal',
		});
	};

	const getRoomID = () => {
		getChatDetailsMutation(`receiverId=${receiverId}`).then((resData: any) => {
			if (resData?.docs?.roomId) {
				navigate(`/chat/${receiverId}/${resData?.docs?.roomId}`);
			} else {
				return false;
			}
		});
	};

	return ['icon'].includes(mode) ? (
		<Button className={className} disabled={isBlock} onClick={handleClick}>
			<i className="ri-chat-3-line"></i>
		</Button>
	) : (
		<Button className={className} disabled={isBlock} onClick={handleClick}>
			{mode === 'sendMsg' ? translate('Chat.sendMsg') : translate('Chat.chat')}
		</Button>
	);
};

export default ChatBtn;
